import { ROUTES } from '../../config/routes';
import Logo from '../../assets/logo.png';
import Container from '../Container';
import AppButtons from './AppButtons';
import './AppFooter.css';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import JoyLink from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import { styled } from '@mui/joy/styles';
import { useState } from 'react';

const Link = styled(JoyLink)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.primary,
  textDecoration: 'none',
  margin: '0 10px',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const AppFooter = ({ showTryApp = true }) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const links = [
    // { url: ROUTES.LOGIN, text: "Login", },
    { url: ROUTES.EULA, text: 'EULA' },
    { url: ROUTES.PRIVACY, text: 'Privacy' },
    { url: ROUTES.FAQ, text: 'FAQ' },
    // { url: ROUTES.CONTACT, text: "Contact", },
  ];

  return (
    <Container>
      <footer id="AppFooter">
        {showTryApp && (
          <>
            <Typography sx={{ pt: 10, pb: 3 }}>Try our beta app:</Typography>
            <div className="footer__app-btns">
              <AppButtons />
            </div>
          </>
        )}
        <div className="footer__copyright">
          <div>
            <img src={Logo} alt={'& Logo'} width={70} />
            <span style={{ fontSize: '0.8rem' }}>Ⓡ</span>
          </div>
          <div style={{ marginTop: 50 }}>
            <Link target={'_blank'} href="https://climate.stripe.com/iG1iO6">
              <span className="and-logo">&</span>&nbsp; is a{' '}
              <span style={{ padding: '0 5px', marginTop: 5 }}>
                <img
                  src="https://a300.stripecdn.com/climate-statics-srv/assets/img/climate_logo-7e2de8ca7243c666c6b0.svg"
                  alt="Stripe Climate Logo"
                  width="auto"
                  height="20"
                />
              </span>
              Stripe Climate member
            </Link>
          </div>
          <div style={{ fontSize: '1rem' }}>
            {links.map((link) => (
              <Link key={link.text} href={link.url}>
                {link.text}
              </Link>
            ))}
            <Link
              href="#"
              onClick={(event) => {
                setOpen(true);
                event.preventDefault();
              }}
            >
              Do Not Sell My Personal Information
            </Link>
            <Modal open={open} onClose={close}>
              <ModalDialog>
                <Typography level="h3" sx={{ color: '#545454' }}>
                  🎉 Surprise!
                </Typography>
                <Typography>
                  We don't sell your info. We hope that adds a little joy to
                  your day. 😎
                </Typography>
              </ModalDialog>
            </Modal>
          </div>
          <Typography
            level="body2"
            sx={{ color: 'var(--and-palette-text-primary)', mb: 1 }}
          >
            & is a For Purpose organization | © {new Date().getFullYear()} The &
            Company
          </Typography>
        </div>
      </footer>
    </Container>
  );
};

export default AppFooter;
